<template>
  <v-card
    class="v-card--material"
    :class="{ 'v-card--material--has-header': hasOffset }"
    :style="styles"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      v-if="hasOffset"
      class="v-card--material__head"
    >
      <slot
        v-if="$slots.offset"
        name="offset"
      />
      <template v-else>
        <span
          class="v-card--material__accent"
          :class="color"
          aria-hidden="true"
        />
        <slot
          v-if="!title && !text"
          name="header"
        />
        <div
          v-else
          class="v-card--material__titles"
        >
          <h4
            class="title-card"
            v-text="title"
          />
          <p
            v-if="text"
            class="category"
            v-text="text"
          />
        </div>
        <!-- Card-level actions, right of the title (e.g. Preview / Download) -->
        <div
          v-if="$slots['head-actions']"
          class="v-card--material__head-actions"
        >
          <slot name="head-actions" />
        </div>
      </template>
    </div>

    <v-card-text>
      <slot />
    </v-card-text>

    <v-divider
      v-if="$slots.actions"
      class="mx-3"
    />

    <v-card-actions v-if="$slots.actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'MaterialCard',

    inheritAttrs: false,

    props: {
      color: {
        type: String,
        default: 'secondary'
      },
      elevation: {
        type: [Number, String],
        default: 10
      },
      inline: {
        type: Boolean,
        default: false
      },
      fullWidth: {
        type: Boolean,
        default: false
      },
      offset: {
        type: [Number, String],
        default: 24
      },
      title: {
        type: String,
        default: undefined
      },
      text: {
        type: String,
        default: undefined
      }
    },

    computed: {
      hasOffset () {
        return this.$slots.header ||
          this.$slots.offset ||
          this.title ||
          this.text
      },
      styles () {
        if (!this.hasOffset) return null

        return {
          marginBottom: `${this.offset}px`
        }
      }
    }
  }
</script>

<style>
.v-application .v-sheet.v-card.v-card--material {
  border: 1px solid var(--esign-border);
  box-shadow: var(--esign-shadow-sm);
  border-radius: var(--esign-radius-lg);
}

.v-card--material__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid var(--esign-border);
}

.v-card--material__accent {
  flex: 0 0 auto;
  width: 4px;
  height: 22px;
  border-radius: 999px;
}

.v-card--material__titles {
  min-width: 0;
}

.v-card--material__head-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.v-card--material .title-card {
  margin: 0;
  color: var(--esign-text);
  font-size: 18px !important;
  font-weight: 700 !important;
  line-height: 1.35 !important;
  letter-spacing: -0.01em;
}

.v-card--material .category {
  margin-top: 2px;
  color: var(--esign-text-muted);
  font-size: 14px !important;
}

@media (max-width: 600px) {
  .v-card--material__head {
    padding: 14px 16px 12px;
  }

  .v-card--material .title-card {
    font-size: 16px !important;
  }
}
</style>
